const parseQueryString = (qs, mapProps) => {
    qs = qs.split('?')[1] || ''
    qs = qs.replace(/^\?/, "")

    return qs.split("&").reduce((obj, part) => {
        if (!part) return obj

        let [key, value] = part.split("=")
        key = decodeURIComponent(key)
        value = decodeURIComponent(value || "")

        if (mapProps && mapProps[key]) {
            key = mapProps[key]
        }

        if (key.endsWith("[]")) {
            let realKey = key.slice(0, -2)

            if (mapProps && mapProps[realKey]) {
                realKey = mapProps[realKey]
            }

            obj[realKey] = obj[realKey] || []
            obj[realKey].push(value)
        } else {
            obj[key] = value
        }

        return obj
    }, {})
}

const toQueryString = (obj) => {
    return Object.entries(obj)
        .filter(([_, v]) => v !== undefined && v !== null)  // bỏ undefined/null
        .map(([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&")
}

const updateWindowLocation = (params, replace = false) => {
    const query = toQueryString(params)
    const newUrl = [window.location.pathname, query].filter(Boolean).join('?')

    if (replace) {
        window.history.replaceState({}, "", newUrl)
    } else {
        window.history.pushState({}, "", newUrl)
    }
}

export {
    parseQueryString,
    toQueryString,
    updateWindowLocation,
}